module.exports = __webpack_public_path__ + "img/fwzn3.ce3e4ab0.png";